import React from 'react'
import './HorizontalSimplePosterCarouselCard.scss'
import classNames from 'classnames'
import { CardProps, RailDetailsItem } from '@interfaces/index'
import { DocumentData } from 'firebase/firestore'
import { ImageExtension, ImageSize } from '@enums/images.enum'
import { useImgUrlTransform } from '@hooks/useImgUrlTransform'
import Image from '@components/Image/Image'
import FallbackImage from '@components/FallbackImage/FallbackImage'

interface HorizontalSimplePosterCarouselCardProps {
  item: CardProps | RailDetailsItem | DocumentData
  isActive?: boolean
}

const HorizontalSimplePosterCarouselCard = ({ item, isActive }: HorizontalSimplePosterCarouselCardProps) => {
  const {
    id,
    title,
    contextData: { imageBackdrop, imageTitle },
  } = item
  const transformedImage = useImgUrlTransform(imageBackdrop, ImageSize.CAROUSEL)
  const transformedImageTitle = useImgUrlTransform(imageTitle, ImageSize.TITLE, ImageExtension.PNG)

  return (
    <div
      className={classNames('hspc-type', {
        'hspc-type__focus': isActive,
      })}
      id={id}
    >
      <div className={classNames('card-image-wrapper', { 'row-card-image-focused': isActive })}>
        {imageBackdrop ? (
          <Image type="poster" image={transformedImage} alt={title} fallbackOnLoad />
        ) : (
          <FallbackImage />
        )}
        {imageTitle && (
          <Image type="title" image={transformedImageTitle} alt={title} className="title" fallbackOnLoad={false} />
        )}
      </div>
    </div>
  )
}
export default HorizontalSimplePosterCarouselCard
